var m4_form = {};

(function ($) {
    'use_strict';
    
    var form = m4_form;
    var m4_object = m4;
    
    /** 
     * Creates an form..
     * @param {jquery element} form
     * @returns {form#1.create_form}
     */
    form.create_form = function(form,_successCallback,_failedCallBack) {
        
        var self = this;
        self.form = form;
        self.btn = self.form.find('button.m4-form-submit');
        self.plups = [];

        /**
         * Inits form
         * @returns {undefined}
         */
        self.init = function () {
            $(window).bind("resize",self.windowResize);
            $(window).trigger("resize"); 
            self.btn.bind("click", self.submitForm);
             
            //Ensure plupload is loaded!            
            if (typeof plupload !== "undefined") {
                self.initplup();
            }
            
        };
        
        /**
         * Inits plupload if defined
         * @returns {undefined}
         */
        self.initplup = function(){
            
            self.form.find('input[plupload="true"]').each(function () {
                var input = $(this);

                input.bind("focus keydown",function(event){   
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    input.trigger("click");
                   
                    return false;
                });
                
                var id = $(this).attr("id");
                var plup = new plupload.Uploader({
                    browse_button: id,
                    multipart: true,
                    multi_selection: false,
                    multipart_params : {id: id, action : "plupload_file",  nonce : m4_plupload.nonce },
                    url: m4_object.ajax_url,
                    filters : [
                        {title : "Image files", extensions : "jpeg,jpg,gif,png"}
                    ]
                });
                
                plup.input = input;
                
                plup.init();
                plup.bind("FilesAdded",self.FilesAdded);
                plup.bind('UploadProgress',self.UploadProgress);
                plup.bind('FileUploaded',self.FileUploaded);
                
                var span = $('<span/>',{
                    class : "loader",
                    html : '<span class="fill"></span><div class="imageholder"></div>',
                    style : "width:" + input.outerWidth() +  "px" 
                }).insertAfter(input);
                
                self.plups.push(plup);
                
            });
        };
        
        /**
         * WindowResize
         * @param {type} event
         * @returns {undefined}
         */
        self.windowResize = function(event){
            var w = self.form.find(".loader").parents("div").find('input[plupload="true"]').outerWidth();
            self.form.find(".loader").css({width : w + "px"});
            var ww = $(window).outerWidth();
            if(ww > 769){
                self.form.find('input[data-type="date"]').each(function(){
                   $(this).attr("type","text");
                });
            }else{
                self.form.find('input[data-type="date"]').each(function(){
                   $(this).attr("type","date"); 
                });
            }
        };
        
        /**
         * File Uploaded
         * @param {type} up
         * @param {type} file
         * @param {type} ret
         * @returns {undefined}
         */
        self.FileUploaded = function (up, file, ret) {
            var uploader = this;
            var data = JSON.parse(ret.response);
            
            if(data.success){
                $("<img/>",{
                   src : data.data.url
                }).appendTo(uploader.input.parent("div").find("span div.imageholder"));
                uploader.input.attr("data-value",data.data.id);
            }
            
            uploader.input.parent("div").find("span.fill").css({"background-color": "#19de00"});
            uploader.input.validate();
            self.removeBtnLoading();
            
        };
        
        /**
         * Upload progress
         * @param {type} up
         * @param {type} file
         * @returns {undefined}
         */
        self.UploadProgress = function(up, file){
            var uploader = this;
            uploader.input.parent("div").find("span.fill").css({"width": file.percent + "%"});
        };
        
        /**
         * Files Added
         * @param {type} up
         * @param {type} files
         * @returns {undefined}
         */
        self.FilesAdded = function(up, files){
            var uploader = this;
            uploader.input.attr("value",files[0]["name"]);
            self.setBtnLoading();
            uploader.input.parent("div").find("span.fill").css({"width": "0px","background-color":"#009cde"});
            uploader.input.parent('div').find("div.imageholder").html("");
            up.start();
        };
        
        self.setBtnLoading = function(){
          self.btn.addClass("loading");
          self.btn.prop('disabled',true);
        };
        
        self.removeBtnLoading = function(){
          self.btn.removeClass("loading");
          self.btn.prop('disabled',false);
        };
        
        self.resetForm = function(){ 
          self.form.trigger("reset");
          self.form.find(".has-success").removeClass("has-success");   
        };
        
        /**
         * submitingForm
         * @param {Eveent} event
         * @returns {Boolean}
         */
        self.submitForm = function (event) {
            
            event.preventDefault();
            event.stopPropagation();

            if (self.btn.hasClass("loading"))
            return false;

            var valid = true;
            var post_data = {
                url: m4_object.ajax_url,
                type : self.form.attr("method"),
                data: {action:self.form.attr("action")},
                success:self.ajax_response
            };
            
            self.form.find('input,textarea').each(function () {
                var input = $(this);
                var name = input.attr("name");                
                var validate = input.validate();
                var type = input.attr("type");

                if(type === 'checkbox' || type === 'radio'){
                    var values = [];
                    self.form.find("input[name='"+name+"']:checked").each(function(){values.push($(this).val());});
                    post_data.data[name] = values;
                }else{
                    post_data.data[name] = input.attr("data-value") ? input.attr("data-value") : input.val();
                }
                
                
                
                
                if(!validate) valid = false;
                
            }); 
 
            if (valid) {
                self.setBtnLoading();
                $.ajax(post_data).complete();
            }

        };
        
        /**
         * Ajax Response
         * @param {JSON} data
         * @param {type} textStatus
         * @param {type} jqXHR
         * @returns {Boolean}
         */
        self.ajax_response = function(data, textStatus, jqXHR){
            if(typeof data === "object"){
                if(data.success){
                    self.removeBtnLoading();
                  _successCallback(data.data,self);
                  return true;
                }
            } 
            
            _failedCallBack(data,self);
            self.removeBtnLoading();
            return false;
        };

        self.init();
        return self;
    };
})(jQuery);